module.exports = __webpack_public_path__ + "img/clapping_hands_3d_default.a7b51acb.png";